import React, { Component } from 'react'
import $ from 'jquery';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { NavbarLog } from '../../navbar/NavbarLog';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, ListGroupItemText } from 'reactstrap';
import { ApiUrl } from '../../services/ApiRest';
import swal from 'sweetalert';

const UrlListarEvaluaciones = ApiUrl + "evaluaciones-docentes?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarPreguntas = ApiUrl + "evaluaciones-preguntas"; // Nueva ruta para obtener preguntas
const UrlInsertarPregunta = ApiUrl + "preguntas?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"; // Ruta para insertar pregunta
const UrlActualizarPregunta = ApiUrl + "preguntas"; // Ruta para modificar pregunta
const UrlInsertarOpcion = ApiUrl + "opciones-respuesta"; // Ruta para opciones
const api_key = "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"
let listaauxiliar = [];
const itemsPerPage = 4;
const tiposPregunta = ["Opción Múltiple", "Abierta"]; // Tipos de preguntas

export default class GestionPreguntasEval extends Component {
    constructor(props) {
        super(props);
        this.state = {
            evaluaciones: [],
            preguntas: [],
            opciones: [],
            listaPreguntas: [],
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            modalPregunta: false,
            evaluacionSeleccionada: "",
            idPregunta: 0,
            tipo: "",
            pregunta: "",
            opcionesRespuesta: [], // Se inicializa vacío
        };
    }

    componentDidMount() {
        this.listarEvaluaciones();
    }

    listarEvaluaciones = async () => {
        axios.get(UrlListarEvaluaciones).then(respuesta => {
            this.setState({ evaluaciones: respuesta.data });
        });
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });

        // Si cambia a "Opción Múltiple", inicializa con una opción
        if (e.target.name === "tipo" && e.target.value === "Opción Múltiple") {
            if (this.state.opcionesRespuesta.length === 0) {
                this.setState({ opcionesRespuesta: [{ texto: "", valor: 1 }] });
            }
        }
    };

    seleccionarEvaluacion = async (e) => {
        const evaluacionId = e.target.value;
        this.setState({ evaluacionSeleccionada: evaluacionId });

        if (evaluacionId) {
            axios.get(`${UrlListarPreguntas}/${evaluacionId}${api_key}`).then(respuesta => {
                const preguntas = Array.isArray(respuesta.data) ? respuesta.data : [];
                this.setState({ preguntas, listaPreguntas: preguntas });
                //Paginacion
                listaauxiliar = preguntas;
                const endOffset = this.state.itemOffset + itemsPerPage;
                this.setState({
                    currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset),
                    pageCount: Math.ceil(listaauxiliar.length / itemsPerPage)
                });
            });
        } else {
            this.setState({ preguntas: [] });
        }
    };

    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        const endOffset = newOffset + itemsPerPage;
        this.setState({
            itemOffset: newOffset,
            currentItems: listaauxiliar.slice(newOffset, endOffset)
        });
    }

    agregarOpcion = () => {
        this.setState((prevState) => ({
            opcionesRespuesta: [...prevState.opcionesRespuesta, { texto: "", valor: 1 }]
        }));
    };

    handleOpcionChange = (index, e) => {
        const { name, value } = e.target;
        const opcionesActualizadas = [...this.state.opcionesRespuesta];
        opcionesActualizadas[index][name] = value;
        this.setState({ opcionesRespuesta: opcionesActualizadas });
    };

    eliminarOpcion = (index) => {
        const nuevasOpciones = this.state.opcionesRespuesta.filter((_, i) => i !== index);
        this.setState({ opcionesRespuesta: nuevasOpciones });
    };

    mostrarModalPregunta = (pregunta = null) => {
        if (pregunta) {
            this.setState({
                idPregunta: pregunta.id,
                tipo: pregunta.tipo,
                pregunta: pregunta.pregunta,
                opcionesRespuesta: pregunta.opciones || [{ texto: "", valor: 1 }]
            });
        } else {
            this.setState({
                idPregunta: 0,
                tipo: "",
                pregunta: "",
                opcionesRespuesta: []
            });
        }
        this.setState({ modalPregunta: true });
    };

    ocultarModalPregunta = () => {
        this.setState({ modalPregunta: false });
    };

    registrarPregunta = async () => {
        const { idPregunta, evaluacionSeleccionada, tipo, pregunta, opcionesRespuesta } = this.state;

        const datosPregunta = {
            evaluacion_docente_id: evaluacionSeleccionada,
            tipo,
            pregunta
        };

        // Si la pregunta es de opción múltiple, añadir las opciones con sus IDs si existen
        if (tipo === "Opción Múltiple") {
            datosPregunta.opciones = opcionesRespuesta.map(opcion => ({
                id: opcion.id || null,  // Si la opción ya tiene ID, se mantiene; si es nueva, se envía null
                texto: opcion.texto,
                valor: opcion.valor
            }));
        }

        const urlPregunta = idPregunta === 0 ? UrlInsertarPregunta : `${UrlActualizarPregunta}/${idPregunta}${api_key}`;
        const metodoPregunta = idPregunta === 0 ? "post" : "put";

        try {
            const responsePregunta = await axios[metodoPregunta](urlPregunta, datosPregunta);

            if (responsePregunta.status === 201 || responsePregunta.status === 200) {
                swal("Operación Exitosa!", { icon: "success" });
                this.seleccionarEvaluacion({ target: { value: evaluacionSeleccionada } });
                this.ocultarModalPregunta();
            }
        } catch (error) {
            console.error("Error en la operación:", error);
            swal("Error al guardar la pregunta. Intente nuevamente.", { icon: "error" });
        }
    };

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item active"></li>
                </ol>
                <div className="card shadow p-3 mb-5 bg-white rounded">
                    <div className="card-header back-istmas">
                        <i className="far fa-sticky-note"></i>
                        <b> Gestión de Preguntas</b>
                    </div>
                    <div className="card-body">
                        <div className="row ">
                            <div className="col-12 col-sm-12 col-lg-1 col-xl-4" >
                                <div className="mb-3">
                                    <label className="form-label"><b>Evaluaciones Docentes</b></label>
                                    <select className="form-select" onChange={this.seleccionarEvaluacion} value={this.state.evaluacionSeleccionada}>
                                        <option value="undefined" selected="true">Seleccione una evaluación:</option>
                                        {this.state.evaluaciones.map((ev) => (
                                            <option key={ev.id} value={ev.id}>{ev.titulo}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        {this.state.preguntas.length > 0 && (
                            <div className="card border-dark text-center ">
                                <div className="card-header ">
                                    <b>REPORTE DE PREGUNTAS</b>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Tipo</th>
                                                <th>Pregunta</th>
                                                <th>Opciones</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.currentItems && this.state.currentItems.map((pregunta) => (
                                                <tr key={pregunta.id}>
                                                    <td>{pregunta.id}</td>
                                                    <td>{pregunta.tipo}</td>
                                                    <td>{pregunta.pregunta}</td>
                                                    <td>
                                                        {pregunta.opciones && pregunta.opciones.map((op, index) => (
                                                            <div key={index}>{op.texto} ({op.valor})</div>
                                                        ))}
                                                    </td>
                                                    <td>
                                                        <button onClick={() => this.mostrarModalPregunta(pregunta)}>
                                                            <i className="fas fa-clipboard-list"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="table-responsive">
                                        <ReactPaginate
                                            nextLabel="siguiente >"
                                            onPageChange={this.handlePageClick}
                                            pageRangeDisplayed={5}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={2}
                                            previousLabel="< anterior"
                                            pageClassName="page-item"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            breakLabel="..."
                                            breakClassName="page-item"
                                            breakLinkClassName="page-link"
                                            containerClassName="pagination"
                                            activeClassName="active"
                                            renderOnZeroPageCount={null}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        <button className="btn btn-primary mt-3" onClick={() => this.mostrarModalPregunta()}>Agregar Pregunta</button>
                    </div>
                </div>

                <Modal isOpen={this.state.modalPregunta}>
                    <ModalHeader>Gestión de Pregunta</ModalHeader>
                    <ModalBody>
                        <label>Pregunta:</label>
                        <input type="text" name="pregunta" className="form-control" value={this.state.pregunta} onChange={this.handleChange} />

                        <label>Tipo:</label>
                        <select name="tipo" className="form-control" value={this.state.tipo} onChange={this.handleChange}>
                            <option value="" selected disabled>Seleccione</option>
                            {tiposPregunta.map(tipo => <option key={tipo}>{tipo}</option>)}
                        </select>
                        <hr />
                        {this.state.tipo === "Opción Múltiple" && (
                            <div>
                                <h5>Opciones de Respuesta</h5>
                                {this.state.opcionesRespuesta.map((opcion, index) => (
                                    <div key={index} className="d-flex mb-2">
                                        <input
                                            type="text"
                                            placeholder="Texto"
                                            className="form-control"
                                            name="texto"
                                            value={opcion.texto}
                                            onChange={(e) => this.handleOpcionChange(index, e)}
                                        />
                                        <input
                                            type="number"
                                            placeholder="Valor"
                                            className="form-control ml-2"
                                            name="valor"
                                            value={opcion.valor}
                                            onChange={(e) => this.handleOpcionChange(index, e)}
                                        />
                                        <button className="btn btn-danger ml-2" onClick={() => this.eliminarOpcion(index)}>X</button>
                                    </div>
                                ))}
                                <button className="btn btn-primary" onClick={this.agregarOpcion}>Agregar Opción</button>
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.registrarPregunta}>Guardar</button>
                        <button className="btn btn-danger" onClick={this.ocultarModalPregunta}>Cancelar</button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}